// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_page_container__90FYi","wrapper":"PrivacyPolicy_page_wrapper__Cy-yw","mainTitle":"PrivacyPolicy_page_mainTitle__eX3Bk"};